import React from "react";
import axios from "axios";
import $ from "jquery";
import Bloodhound from 'bloodhound-js';
import 'typeahead.js';
import select2 from "select2";
import {
    getFromLocalStorage,
    strstr
} from './Utilities';

class SegmentList extends React.Component {

    constructor(props){
        super(props);
        this.myRef = React.createRef();

        this.state = {
            "segments": {},
            "selectedSegment": null,
            "brandCount": 0, //used to count how many segment sets need to be loaded
            "segmentIterator": 0, //counts each segment set as it is added, when equals above we know everything is loaded
            "allSegmentsLoaded": false,
            "segmentListLoaded": false,
            "status": props.status
        };
    }

    componentDidMount() {
        if(this.state.status === "active") this.getData();
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(this.state.allSegmentsLoaded && !this.state.segmentListLoaded) {
            if(this.props.type === "typeahead"){
                this.createTypeahead();
            } else {//otherwise select2
                this.createSelect2();
            }
            this.setState({
                "segmentListLoaded": true
            });
        }
    }

    createTypeahead(){        
        var segments_object = this.state.segments;
        var segments_array = Object.keys(segments_object).map(function (key) { return segments_object[key]; });

        var segments = new Bloodhound({
            local: segments_array,
            limit: 10,
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('Name'),
            queryTokenizer: Bloodhound.tokenizers.whitespace
        });
        segments.initialize();

        var options = {
            hint: true,
            highlight: true,
            minLength: 1
        };

        const source = {
            name: 'segments',
            displayKey: 'name',
            multiple: true,
            templates: {
                suggestion: function (data) {
                    return '<div class="segment" data-segment-id="'+data.ID+'">'+data.Name+'</div>';
                }
            },
            source: segments.ttAdapter()
        };
        $(this.myRef.current).typeahead(options, source);

        var parent = this;
        $(this.myRef.current).bind('typeahead:selected', function(selected, obj) {
            parent.handleTypeaheadSelected(obj);
        });  
        $(this.myRef.current).keypress(function(event){
            if (event.which === '13') {//block enter button, as we use segment typeahead as a filter and we don't want to clear it
              event.preventDefault();
            }
        });
    }

    createSelect2(){
        var filters = getFromLocalStorage("report_data");
        if(filters && Object.keys(filters).length > 0){
            if(filters && filters.ChooseActivities && filters.ChooseActivities.Segment && filters.ChooseActivities.Segment.ID){
                this.setState({
                    "selectedSegment": parseInt(filters.ChooseActivities.Segment.ID)
                });
            }
        }
        
        var parent = this;
        $(this.myRef.current).on('change', function(event, val) {
            parent.setState({
                "selectedSegment": parseInt($(this).val())
            });
        });
        $(this.myRef.current).select2();

        $(this.myRef.current).bind('change', function(obj) {
            //use $(this).attr("data-segment-name") for segment name here as $(obj.target).data("segment-name") doesn't seem to update each time
            var segmentData = {"Segment": {"type": "Segment", "ID": obj.target.value, "Name": $(this).attr("data-segment-name")}};
            if(strstr(window.location.pathname, "reports")) parent.props.onChange(segmentData);
            else window.ReportCriteria.updateFilters("ChooseActivities", segmentData);
            parent.handleTypeaheadSelected(obj);
        });         
    }

    getData(){
        var brandids = this.getBrandIDs();

        this.setState({
            "brandCount": brandids.length
        });

        var cacheKey = $(".segmentlistcachekey").data("segmentlistcachekey");
        var parent = this;

        $(Object.values(brandids)).each(function(key, id){
            var url = "";
            if(id === "<UmbrellaID>") 
                url = "react/process?endpoint=segments&orderBy=Created+DESC&excludeBasicSocial=1&limit=1000&turnoffdebug=1";
            else
                url = "react/process?endpoint=brand/"+id+"/segments&orderBy=ID+ASC&isactive=1&turnoffdebug=1"; 

            if(parent.props?.IgnoreSegmentFilters === "true") url += "&IgnoreSegmentFilters=1";

            if(cacheKey) url += "&cacheKey="+cacheKey;
            axios.get(url).then(response => parent.formatData(response.data));
        }); 
    }

    getBrandIDs(){
        var brandids = [];
        if(this.props.type === "select"){
            var filters = getFromLocalStorage("report_data");
            if(Object.keys(filters).length > 0){
                if(filters.ChooseBrands){
                    $(Object.values(filters.ChooseBrands)).each(function(key, brand){
                        brandids[key] = brand['ID'];
                    })
                }
            }
        }
        if(brandids.length === 0) brandids[0] = "<UmbrellaID>";//default to umbrella
        return brandids;  
    }

    //gets data from api and adds it to typeahead activities
    formatData(data){

        var segments = this.state.segments;
        if(Object.keys(data).length > 0){
            $(data).each(function(key, segment){
                segments[parseInt(segment.ID)] = segment;
            });
        }

        var segmentData = {
            segments: segments,
            segmentIterator: this.state.segmentIterator+1
        }

        if(this.props.type === "typeahead"){
            segmentData.allSegmentsLoaded = true;//typeahead will always be based on a single umbrella brand
        } else if(segmentData.segmentIterator > 0 && (segmentData.segmentIterator === this.state.brandCount)){
            segmentData.allSegmentsLoaded = true;
        }

        this.setState(segmentData);   
    }

    handleTypeaheadSelected(obj){
        $('#SegmentSelector').typeahead('val', obj.Name);
        if(this.props.type === "typeahead") this.props.sendToPage(obj.Name);
    }

    render() {
        const segments = this.state.segments ? this.state.segments : {};
        if(this.props.type === "typeahead") return this.renderTypeahead(segments)
        return this.renderSelect(segments);
    }

    renderSelect(segments){        
        segments = {0: {"ID": "All", "Name": "All segments (default)"}, ...segments};
        var selectedSegment = (this.state.selectedSegment && Object.keys(segments).length > 0) ? segments[this.state.selectedSegment] : null;
        var selectedSegmentName = selectedSegment ? selectedSegment.Name : null;
        var selectedSegmentID = selectedSegment ? selectedSegment.ID : 0;
        
        if(this.state.allSegmentsLoaded){
            var selectedOption = "";
            if(selectedSegment){//push already selected to top and display
                $(this.myRef.current).val(selectedSegmentID);
                selectedOption = <option key={selectedSegmentID} value={selectedSegmentID}>{selectedSegmentName}</option>;
            }

            return(
                <div id="SegmentSelectorHolder">
                    <select id="SegmentSelector" ref={this.myRef} style={this.props.inputStyle} 
                        data-segment-name={selectedSegmentName} defaultValue={selectedSegmentID}>
                        {selectedOption}
                        {Object.entries(segments).map(function(obj, key) {
                            if(obj[1].ID !== selectedSegmentID) return <option key={key} value={obj[1].ID}>{obj[1].Name}</option>;
                        })}
                    </select>
                </div>
            );
        } else {
            return( 
                <div id="SegmentSelectorHolder">
                    <div className="react-loading horizontal small mt2"></div>
                </div>
            );
        }
    }

    renderTypeahead(segments){
        return(
            <div>
                <input type="text" id="SegmentSelector" ref={this.myRef} style={this.props.inputStyle} />
            </div>
        );
    }
}

SegmentList.defaultProps = {
    type: "select",
    inputStyle: {
        'width': '100%',
        'height': '32px',
        'marginTop': "-2px"

    },
    loaderStyle: {
        "height": "32px",
        "margin": "-31px 0 0 2px"
    }
};

export default SegmentList;
